import Box from '@mui/material/Box';
import { object } from 'prop-types';
import React from 'react';

const DEVICE_WIDTH = 280;
const px = n => `${n}px`;

const deviceSx = {
  position: 'relative',
  width: DEVICE_WIDTH,
  height: DEVICE_WIDTH * 2,
};

const frameSx = theme => ({
  background: theme.palette.secondary.light,
  borderRadius: px(DEVICE_WIDTH * 0.158878505),
  boxShadow: `inset 0 0 0px 5px ${theme.palette.secondary.light}, inset 0 0 0 7px ${theme.palette.secondary.extraLight}`,
  padding: px(DEVICE_WIDTH * 0.065),
  width: DEVICE_WIDTH,
  height: DEVICE_WIDTH * 2,
});

const contentSx = theme => ({
  height: DEVICE_WIDTH * 2 - DEVICE_WIDTH * 0.065 * 2,
  width: DEVICE_WIDTH - DEVICE_WIDTH * 0.065 * 2,
  borderRadius: px(DEVICE_WIDTH * 0.106666667),
  background: theme.palette.background.paper,
  overflow: 'hidden',
  display: 'flex',
});

const stripeSx = theme => ({
  zIndex: 9,
  '&:after, &:before': {
    border: `solid ${theme.palette.secondary.main}`,
    borderWidth: `0 ${DEVICE_WIDTH * 0.01635514}px`,
    content: `''`,
    height: DEVICE_WIDTH * 0.01635514,
    left: 0,
    position: 'absolute',
    width: '100%',
    zIndex: 9,
  },
  '&:after': {
    top: px(DEVICE_WIDTH / 20),
    border: 'none',
  },
  '&:before': {
    bottom: px(DEVICE_WIDTH / 20),
    border: 'none',
  },
});

const headerSx = theme => ({
  zIndex: 10,
  background: theme.palette.secondary.light,
  borderBottomLeftRadius: px(DEVICE_WIDTH * 0.046728972),
  borderBottomRightRadius: px(DEVICE_WIDTH * 0.046728972),
  height: DEVICE_WIDTH * 0.07,
  left: '50%',
  marginLeft: px(-DEVICE_WIDTH * 0.238317757),
  position: 'absolute',
  top: px(DEVICE_WIDTH * 0.065),
  width: DEVICE_WIDTH * 0.476635514,
  '&::after, &::before': {
    zIndex: 10,
    content: `''`,
    height: DEVICE_WIDTH * 0.023364486,
    position: 'absolute',
    top: 0,
    width: DEVICE_WIDTH * 0.023364486,
  },
  '&::after': {
    background: `radial-gradient(circle at bottom left, transparent 0, transparent 75%, ${theme.palette.secondary.light} 75%, ${theme.palette.secondary.light} 100%)`,
    left: px(-DEVICE_WIDTH * 0.023364486),
  },
  '&::before': {
    background: `radial-gradient(circle at bottom right, transparent 0, transparent 75%, ${theme.palette.secondary.light} 75%, ${theme.palette.secondary.light} 100%)`,
    right: px(-DEVICE_WIDTH * 0.023364486),
  },
});

const sensorsSx = theme => ({
  zIndex: 10,
  '&::after, &::before': {
    zIndex: 10,
    content: `''`,
    position: 'absolute',
  },
  '&::after': {
    background: theme.palette.white,
    borderRadius: px(DEVICE_WIDTH * 0.074766355),
    height: DEVICE_WIDTH * 0.014,
    left: '50%',
    marginLeft: px(-DEVICE_WIDTH * 0.058411215),
    top: px(DEVICE_WIDTH * 0.074766355),
    width: DEVICE_WIDTH * 0.11682243,
  },
  '&::before': {
    background: theme.palette.white,
    borderRadius: '50%',
    height: DEVICE_WIDTH * 0.03271028,
    left: '50%',
    marginLeft: px(DEVICE_WIDTH * 0.093457944),
    top: px(DEVICE_WIDTH * 0.065),
    width: DEVICE_WIDTH * 0.03271028,
  },
});

const buttonsSx = theme => ({
  background: theme.palette.secondary.medium,
  height: DEVICE_WIDTH * 0.074766355,
  left: px(-DEVICE_WIDTH * 0.007009346),
  position: 'absolute',
  top: px(DEVICE_WIDTH * 0.268691589),
  width: DEVICE_WIDTH * 0.007009346,
  '&::after, &::before': {
    background: theme.palette.secondary.medium,
    content: `''`,
    height: DEVICE_WIDTH * 0.144859813,
    left: 0,
    position: 'absolute',
    width: DEVICE_WIDTH * 0.007009346,
  },
  '&::after': {
    top: px(DEVICE_WIDTH * 0.140186916),
  },
  '&::before': {
    top: px(DEVICE_WIDTH * 0.327102804),
  },
});

const powerSx = theme => ({
  background: theme.palette.secondary.medium,
  height: DEVICE_WIDTH * 0.23364486,
  right: px(-DEVICE_WIDTH * 0.007009346),
  position: 'absolute',
  top: px(DEVICE_WIDTH * 0.46728972),
  width: DEVICE_WIDTH * 0.007009346,
});

const IphonePreview = ({ children = null }) => {
  return (
    <Box sx={deviceSx}>
      <Box sx={frameSx}>
        <Box sx={contentSx}>{children}</Box>
      </Box>
      <Box sx={stripeSx} />
      <Box sx={headerSx} />
      <Box sx={sensorsSx} />
      <Box sx={buttonsSx} />
      <Box sx={powerSx} />
    </Box>
  );
};

IphonePreview.propTypes = {
  children: object,
};

export default IphonePreview;
